// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_574e263","total":"_cc568bb","bottom":"_56d80ff","pay":"_5802173","delimeter":"_a90f496"};